var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrosshair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 241,
    viewBox: "0 0 273 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 214.087C209.287 214.087 246 177.222 246 131.745C246 86.2694 209.287 49.4038 164 49.4038C118.713 49.4038 82 86.2694 82 131.745C82 177.222 118.713 214.087 164 214.087Z",
    stroke: "#364A43",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164 181.151C191.172 181.151 213.2 159.031 213.2 131.746C213.2 104.46 191.172 82.3406 164 82.3406C136.828 82.3406 114.8 104.46 114.8 131.746C114.8 159.031 136.828 181.151 164 181.151Z",
    stroke: "#364A43",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164 49.4038V214.087V49.4038ZM82 131.745H246H82Z",
    fill: "#364A43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164 49.4038V214.087M82 131.745H246",
    stroke: "#364A43",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164 136.689C166.717 136.689 168.92 134.477 168.92 131.749C168.92 129.02 166.717 126.808 164 126.808C161.283 126.808 159.08 129.02 159.08 131.749C159.08 134.477 161.283 136.689 164 136.689Z",
    fill: "#364A43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshair);
export default __webpack_public_path__ + "static/media/crosshair.988c3c9f4e7a160b0367d03224bd3031.svg";
export { ForwardRef as ReactComponent };